import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  const navItems = ['Home', 'Services', 'Who We Help', 'Process', 'Packages', 'Success Stories'];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-black/90 backdrop-blur-sm shadow-lg py-3' : 'bg-transparent py-5'}`} data-id="element-145">
      <div className="container mx-auto px-4 flex justify-between items-center" data-id="element-146">
        <div className="flex items-center" data-id="element-147">
          <a href="#home" className="text-2xl font-bold text-white flex items-center transition-transform hover:scale-105" data-id="element-148">
            <span className="bg-gradient-to-r from-white to-blue-primary bg-clip-text text-transparent animate-pulse" data-id="element-149">
              CALLVANA
            </span>
          </a>
        </div>
        <nav className="hidden md:flex items-center space-x-8" data-id="element-150">
          {navItems.map(item => <a key={item} href={`#${item.toLowerCase().replace(/\s+/g, '-')}`} className="text-white hover:text-blue-light transition-colors uppercase text-sm tracking-wider font-medium relative group" data-id="element-151">
              {item}
              <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-blue-light transition-all duration-300 group-hover:w-full" data-id="element-152"></span>
            </a>)}
          <a href="#contact" className="bg-gradient-to-r from-blue-primary to-blue-light hover:from-blue-dark hover:to-blue-primary text-white px-6 py-2 rounded uppercase font-bold text-sm tracking-wider transition-all transform hover:scale-105 relative overflow-hidden group" data-id="element-153">
            <span className="relative z-10" data-id="element-154">Contact Us</span>
            <span className="absolute inset-0 bg-white opacity-0 group-hover:opacity-20 transition-opacity duration-300" data-id="element-155"></span>
          </a>
        </nav>
        <button className="md:hidden text-white" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-156">
          {mobileMenuOpen ? <X size={24} data-id="element-157" /> : <Menu size={24} data-id="element-158" />}
        </button>
      </div>
      {/* Mobile menu */}
      {mobileMenuOpen && <div className="md:hidden bg-black/95 absolute top-full left-0 w-full py-4 shadow-lg backdrop-blur-sm" data-id="element-159">
          <div className="container mx-auto px-4 flex flex-col space-y-4" data-id="element-160">
            {navItems.map(item => <a key={item} href={`#${item.toLowerCase().replace(/\s+/g, '-')}`} className="text-white hover:text-blue-light transition-colors py-2 uppercase text-sm tracking-wider font-medium" onClick={() => setMobileMenuOpen(false)} data-id="element-161">
                {item}
              </a>)}
            <a href="#contact" className="bg-gradient-to-r from-blue-primary to-blue-light hover:from-blue-dark hover:to-blue-primary text-white px-6 py-2 rounded text-center uppercase font-bold text-sm tracking-wider" onClick={() => setMobileMenuOpen(false)} data-id="element-162">
              Contact Us
            </a>
          </div>
        </div>}
    </header>;
};